const blacklistRoles = [
  'redirect',
  'emailTemplate',
  'configErrorsPage'
];

export default blacklistRoles;
